import hash from 'object-hash';

import type { Extension } from '../../../web-client';

export const getEgressHash = (egress: Extension['egress'], overrides: Extension['overrides']) =>
	hash({ egress, overrides }, { unorderedArrays: true, unorderedObjects: true });
